export const PREF_CARDS_BASE_ROUTE = 'preference-cards';
const PREF_CARDS_BASE_PATH = `/${PREF_CARDS_BASE_ROUTE}`;
export default PREF_CARDS_BASE_PATH;

const PROCEDURE_CARDS_BASE_ROUTE = `${PREF_CARDS_BASE_PATH}/procedures`;
export const PROCEDURE_CARDS_BASE_PATH = `${PROCEDURE_CARDS_BASE_ROUTE}`;
